// 是否数字
const isNumber = input => {
  if (['number', 'string'].indexOf(typeof input) > -1) {
    return !isNaN(Number(input))
  }
  return false
}
// 是否整数
const isInteger = input => {
  if (isNumber(input)) {
    const num = Number(input)
    return (num * 2) % 2 === 0
  }
  return false
}
// 是否非负整数
const isPositiveInteger = input => {
  if (isInteger(input)) {
    const num = Number(input)
    return num > 0
  }
  return false
}
const price = (value, digitcount, pointcount) => {
  // console.log(value, digitcount, pointcount)
  if (!(isNumber(value) && value >= 0)) {
    return ''
  }
  let s = value
  if (isPositiveInteger(digitcount)) {
    const n = String(value).length - String(value).indexOf('.') - 1
    /*eslint-disable*/
        const newprice = value * Math.pow(10, n) / Math.pow(10, n + digitcount)
        s = String(newprice)
        }
        if (pointcount && isPositiveInteger(pointcount)) {
        let rs = s.indexOf('.')
        if (rs < 0) {
            s += '.'
            rs = s.indexOf('.')
        }
        if (s.length - rs > pointcount) {
            s = s.slice(0, rs + pointcount + 1)
        } else {
            s = s.padEnd(rs + 1 + pointcount, '0')
        }
        }
        // console.log(value, digitcount, pointcount, s)
        return s
    }
    export default price